<template>
  <div class="page-with-subnav">
    <app-sub-navigation-bar
      back-label="Back to all customers"
      @back="$router.push('/contact')"
    />
    <div class="main-container page-with-subnav__content">
    <div class="ui grid customer-form-grid">
      <div class="sixteen wide column">
        <h1><i class="address book outline icon"></i> New Customer</h1>
      </div>
      <div class="sixteen wide column">
        <app-form-error></app-form-error>
        <form class="ui form">
          <div class="field settings">
            <label>Customer Name *</label>
            <app-text-input placeholder="Enter person or company name" type="text" v-model="contact.company" :error="!contact.company && submitted" />
          </div>

          <h4 class="ui dividing header">Primary Contact</h4>
          <div class="two fields">
            <div class="field settings">
              <label>First Name</label>
              <app-text-input placeholder="Enter first name" type="text" v-model="contact.first_name" />
            </div>
            <div class="field settings">
              <label>Last Name</label>
              <app-text-input placeholder="Enter last name" type="text" v-model="contact.last_name" />
            </div>
          </div>
          <div class="three fields">
            <div class="field settings">
              <label>Phone Number</label>
              <app-text-input placeholder="Enter phone number" type="text" v-model="contact.phone" />
            </div>
            <div class="field settings">
              <label>Mobile Number</label>
              <app-text-input placeholder="Enter mobile number" type="text" v-model="contact.mobile" />
            </div>
            <div class="field settings">
              <label>Email Address *</label>
              <app-text-input placeholder="Enter email address" type="email" v-model="contact.email" :error="!contact.email && submitted" />
            </div>
          </div>

          <h4 class="ui dividing header">Physical Address</h4>
          <div class="field settings">
            <label>Street Address</label>
            <app-text-input placeholder="Enter street address" type="text" v-model="contact.street_address" />
          </div>
          <div class="three fields">
            <div class="field settings">
              <label>Suburb</label>
              <app-text-input placeholder="Enter suburb" type="text" v-model="contact.suburb" />
            </div>
            <div class="field settings">
              <label>Postcode</label>
              <app-text-input placeholder="Enter postcode" type="text" v-model="contact.postcode" />
            </div>
            <div class="field settings">
              <label>State</label>
              <app-select
                :defaultLabel="'Select state'"
                :items="$store.getters['getStates']"
                :value="contact.state || ''"
                @selected="contact.state = $event.id"
              />
            </div>
          </div>

          <h4 class="ui dividing header">Postal Address</h4>
          <div class="field settings">
            <app-checkbox v-model="postalSameAsPhysical" label="Same as Physical Address" />
          </div>
          <template v-if="!postalSameAsPhysical">
            <div class="field settings">
              <label>Street Address</label>
              <app-text-input placeholder="Enter street address" type="text" v-model="contact.postal_street_address" />
            </div>
            <div class="three fields">
                <div class="field settings">
                  <label>Suburb</label>
                  <app-text-input placeholder="Enter suburb" type="text" v-model="contact.postal_suburb" />
                </div>
                <div class="field settings">
                  <label>Postcode</label>
                  <app-text-input placeholder="Enter postcode" type="text" v-model="contact.postal_postcode" />
                </div>
                <div class="field settings">
                  <label>State</label>
                  <app-select
                    :defaultLabel="'Select state'"
                    :items="$store.getters['getStates']"
                    :value="contact.postal_state || ''"
                    @selected="contact.postal_state = $event.id"
                  />
                </div>
            </div>
          </template>

          <h4 class="ui dividing header">Financial Information</h4>
          <div class="two fields">
            <div class="field settings">
              <label>ABN</label>
              <app-text-input placeholder="Enter ABN" type="text" v-model="contact.abn" />
            </div>
            <div class="field settings">
              <label>ACN</label>
              <app-text-input placeholder="Enter ACN" type="text" v-model="contact.acn" />
            </div>
          </div>

          <div class="field customer-form-actions">
            <button type="button" class="ui primary button" @click="save">Save Changes</button>
          </div>
        </form>
      </div>
    </div>
      </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import SubNavigationBar from '../../components/common/SubNavigationBar.vue'

  export default {
    name: 'CustomerNew',
    components: {
      'app-sub-navigation-bar': SubNavigationBar
    },
    data () {
      return {
        submitted: false,
        postalSameAsPhysical: true,
        contact: {
          company_id: null,
          company: '',
          first_name: '',
          last_name: '',
          email: '',
          phone: '',
          mobile: '',
          street_address: '',
          suburb: '',
          state: '',
          postcode: '',
          postal_street_address: '',
          postal_suburb: '',
          postal_state: '',
          postal_postcode: '',
          abn: '',
          acn: ''
        }
      }
    },
    methods: {
      save () {
        this.submitted = true
        if (!this.contact.company || !this.contact.company.trim()) {
          this.errorNotification('Customer name is required')
          return
        }
        if (!this.contact.email || !this.contact.email.trim()) {
          this.errorNotification('Email address is required')
          return
        }
        const payload = Object.assign({}, this.contact)
        if (this.postalSameAsPhysical) {
          payload.postal_street_address = ''
          payload.postal_suburb = ''
          payload.postal_state = ''
          payload.postal_postcode = ''
        }
        axios.post('/api/contact', payload)
          .then(() => {
            this.successNotification('Customer created successfully')
            this.$router.push('/contact')
          })
          .catch(err => {
            const msg = err.response && err.response.data && err.response.data.error ? err.response.data.error : (err.message || 'Failed to create customer')
            this.errorNotification(msg)
          })
      }
    },
    mounted () {
      this.$nextTick(() => { $(this.$el).find('.ui.checkbox').checkbox() })
    }
  }
</script>

<style scoped>
.page-with-subnav__content.main-container {
  margin-top: 16px;
}
.customer-form-grid {
    max-width: 680px;
    margin-left: 0;
    margin-right: 0;
  }
</style>
